/* global AdobeDC */

import { onReady } from "../../utils/events/onReady";

export class PdfEmbed {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(domReference));
    }

    init(domReference) {
        if (!window.AdobeDC) {
            console.error(
                "Adobe PDF Embed failed to load. Please check your configuration."
            );
            return;
        } else {
            var adobeDCView = new AdobeDC.View({
                clientId: domReference.dataset.clientId,
                divId: domReference.id
            });

            adobeDCView.previewFile(
                {
                    content: {
                        location: {
                            url: domReference.dataset.pdfHref
                        }
                    },
                    metaData: {
                        fileName: "PDF Document"
                    }
                },
                {
                    embedMode: domReference.dataset.embedMode
                }
            );
        }
    }
}
